import React from 'react';
import { SiteAlert } from '@trussworks/react-uswds';

export function USWDSSiteAlert(props) {
  return <SiteAlert {...props} />;
}
